import useUpdateEffect from '@restart/hooks/useUpdateEffect';
import classNames from 'classnames/bind';
import React, { useMemo } from 'react';
import { RiCloseLine } from 'react-icons/ri';
import { useDispatch, useSelector } from 'react-redux';

import styles from './Controller.module.scss';

import actions from '@/actions';
import commandSet from '@/define/commandSet';

const cx = classNames.bind(styles);

const Controller = () => {
  const dispatch = useDispatch();
  const robots = useSelector((state) => state.robots);
  const targetRobotIds = useSelector((state) => state.robot.targetRobotIds);
  const overlayCommandId = useSelector((state) => state.command.overlayCommandId);

  const targetRobots = useMemo(() => {
    return robots.filter(({ id }) => targetRobotIds.includes(id));
  }, [robots, targetRobotIds]);

  const command = useMemo(() => commandSet[overlayCommandId], [overlayCommandId]);

  useUpdateEffect(() => {
    dispatch(actions.command.resetActivePanels());
  }, [targetRobotIds]);

  const handleClose = () => {
    dispatch(actions.command.resetActivePanels());
  };

  if (command?.displayMode !== 'overlay') return null;

  const { Panel } = command;

  return (
    <div className={cx(['container', { show: overlayCommandId }])}>
      <div className={cx('close')} onClick={handleClose}>
        <RiCloseLine size={16} color="white" />
      </div>
      <Panel data={targetRobots} />
    </div>
  );
};

export default Controller;
